import React from 'react';
import './AboutPAPT.css';  // Import the corresponding CSS file for styling

const transport = () => {
  return (
    <div className="about-container">
      <div className="content">
      <h1>PRINCIPAL'S MESSAGE</h1>
      <div className="yellow-line1"></div>
        <p>
Dear All,<br></br>
It gives me immense pleasure to welcome you to P.A. Polytechnic, which has earned the unique reputation as one of the leading Polytechnic institutes in Karnataka. I extend my hearty congratulations to all our students for taking a wise decision of choosing P.A. Polytechnic to fulfill their educational aspirations.

Technical education plays a vital role in the social and economic progress of our nation. Technical education has become an indispensable part of our life as every passing day a new gadget is released in the market that serves to improve our living standards. To keep pace with the rapidly changing technical scenario, the students at P.A. Polytechnic are regularly exposed to seminars and workshops conducted by eminent personalities from industry and academia. We thus provide a perfect platform to ignite the minds and fire the imagination of our bright young students to enhance their leadership qualities, creativity and innovative skills.

We at P.A. Polytechnic through the members of our staff, work collectively and systematically to promote the growth of this institution in making it the number one choice of students to pursue their technical education

It gives me a sense of pride to see our student’s progress ahead towards excellence in their chosen field. I wish them all the very best and I assure to be associated with them in achieving and fulfilling their academic aspirations throughout their stay in our campus and even after.

       </p>
       
      </div>
      <div className="ed">
      <div style={{ textAlign: "center" }}>
        <img src="/images/principal.jpg" />
        <p style={{ fontWeight: "bold", fontSize: "18px", margin: "5px 0" }}>Prof. Ismail Khan</p>
        <p style={{ fontWeight:"bold",fontSize: "14px", margin: "0" }}>
    Principal, PAPT
  </p>
  <p style={{ fontSize: "14px", margin: "0" }}>
     P A Educational Trust (Regd.)
  </p>
  
  </div>
      </div>
    </div>
  );
};

export default transport;
